/* src/app/shared/components/form-message/form-message.component.css */
.po-field-container-bottom-text-error {
  color: #be3e37;
}
.po-icon {
  height: 100%;
}
/*# sourceMappingURL=form-message.component.css.map */
